import React from 'react';
import { KiteGridCell, KiteIcon } from '@kite/react-kite';
import styles from 'components/footer/styles/Footer.module.scss';
import SocialMediaIcon from 'components/footer/SocialMediaIcon';
import {
  getPortalFooterLinkContactUs,
  getPortalFooterLinkCustomerCommitment,
  getPortalFooterLinkEnergyUsage,
  getPortalFooterLinkFindStore,
  getPortalFooterLinkWeatherOutage,
} from 'app-constants';
import FooterColumnLink from './FooterColumnLink';
import { isSMBPortal } from 'utils/applicationHelper';

const SocialMedia: React.FC = () => {
  return (
    <KiteGridCell col={12} lg={2} className={`${styles.socialMediaColumn} ${styles.column}`}>
      <div className={styles.row}>
        <div className={styles.space} />
        <div className={styles.socialColumn}>
          <div className={styles.iconLink}>
            <KiteIcon className={`${styles.linkIcon} ${styles.locationIcon}`} icon="ki-map-point-f" />
            <FooterColumnLink {...getPortalFooterLinkFindStore()} />
          </div>
          <div className={styles.iconLink}>
            <KiteIcon className={`${styles.linkIcon} ${styles.lightning}`} icon="ki-lightning-f" />
            <FooterColumnLink {...getPortalFooterLinkWeatherOutage()} />
          </div>
          <div className={styles.iconLink}>
            <KiteIcon className={`${styles.linkIcon} ${styles.lightning}`} icon="ki-heart" />
            <FooterColumnLink {...getPortalFooterLinkCustomerCommitment()} />
          </div>
          {!isSMBPortal() && (
            <div className={styles.iconLink}>
              <KiteIcon className={`${styles.linkIcon} ${styles.energyIcon}`} icon="ki-leaf" />
              <FooterColumnLink {...getPortalFooterLinkEnergyUsage()} />
            </div>
          )}
          <div className={styles.iconLink}>
            <KiteIcon className={`${styles.linkIcon} ${styles.chat}`} icon="ki-chat-support" />
            <FooterColumnLink {...getPortalFooterLinkContactUs()} />
          </div>

          <div className={styles.footerSocialIcons}>
            <SocialMediaIcon />
          </div>
        </div>
        <div className={styles.space} />
      </div>
    </KiteGridCell>
  );
};

export default SocialMedia;
